import React, { useContext } from "react";
import { useState } from "react";
import "./ResetPassword.css";
import "./SignInForm.css";
import { ReactComponent as Close } from "../../assets/icons/x.svg";
import { Check, Loader } from "react-feather";
import axios from "axios";
import { NotificationContext } from "../../Context/NotificationContext";
import { FormTextInput } from "../../Components/FormTextInput";
import { getFullHttpUrl } from "../../firebase.config";
import { EAST4 } from "../../utility/enums";

export default function ResetPassword({
  isLoginOpen,
  backToSignIn,
  handlePasswordChanged,
  email,
}) {
  const [newPassword, setNewPassword] = useState("");
  const { showNotification } = useContext(NotificationContext);
  const [isLoading, setIsLoading] = useState(false);
  const [passwordError, setPasswordError] = useState(false);

  const [btnText, setBtnText] = useState("Reset Password");

  const updatePassword = async () => {
    if (email === "" || newPassword === "" || newPassword.length < 6) {
      setPasswordError(true);
      return;
    }

    setIsLoading(true);
    setBtnText("Reseting");

    try {
      const response = await axios.post(
        getFullHttpUrl("resetUserPassword",EAST4),
        {
          email: email.toLowerCase(),
          password: newPassword,
        }
      );

      if (response.status === 200 && response.data === "success") {
        handlePasswordChanged();
      } else {
        showNotification(
          "Error",
          "Error occurred while resetting password. Please try again or contact support!",
          "error"
        );
      }
    } catch (error) {
      console.log(error);
      showNotification(
        "Error",
        "An error occurred while resetting the password. Please try again later.",
        "error"
      );
    } finally {
      setIsLoading(false);
      setBtnText("Reset Password");
    }
  };

  const handleNewPassword = (value) => {
    setPasswordError(false);
    setNewPassword(value);
  };

  const triggerEnter = () => {
    if (!(newPassword === "")) {
      updatePassword();
    }
  };

  const handlePasswordBlur = () => {
    if (newPassword === "" || newPassword.length < 6) {
      setPasswordError(true);
    }
  };

  return (
    <div className="resetPasswordForm">
      <div className="resetPasswordFormHeader">
        <h2 className="resetPasswordFormTitle">Reset password</h2>
        <Close
          className="resetPasswordFormIcon"
          onClick={() => isLoginOpen()}
        />
      </div>

      <div className="resetPasswordInputContainer">
        <FormTextInput
          password={true}
          showPasswordIcon={true}
          incorrect={passwordError}
          placeholder={"New Password"}
          value={newPassword}
          onBlur={handlePasswordBlur}
          onChange={handleNewPassword}
          onKeyDown={(e) => e.key === "Enter" && triggerEnter()}
        />
      </div>

      {newPassword && (
        <span
          className={`passwordValidation ${
            newPassword.length === 0
              ? "invisibleMessage"
              : passwordError
              ? "passwordError"
              : newPassword.length >= 6
              ? "passwordSuccess"
              : "passwordDefault"
          }`}
        >
          <Check className="passwordCheck" />
          At least 6 characters
        </span>
      )}

      <button
        className="resetPasswordFormButton"
        disabled={newPassword === "" || isLoading || passwordError}
        onClick={() => updatePassword()}
      >
        {btnText}
        {isLoading && <Loader className="btnLoader" />}
      </button>
      <span className="resetPasswordFormLogIn" onClick={() => backToSignIn()}>
        Back to Sign In
      </span>
    </div>
  );
}
